// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__uD0HN","footerTop":"Footer_footerTop__L0GT7","footerBottom":"Footer_footerBottom__ZB4dn","footerRight":"Footer_footerRight__+YUSp"};